import { IPaginationInput } from '@models/payload/customer';
import { CreateFoodShiftPayload, UpdateFoodShiftPayload } from '@models/payload/foodShift';
import { ropoloRequest } from '@services/axios';

const getFoodShifts = async (params: IPaginationInput) => (await ropoloRequest.catalogFoodshiftsList(params)).data;
const getAllFoodShifts = async () => (await ropoloRequest.catalogFoodshiftsListList()).data;
const getFoodShiftsId = async (id: string) => (await ropoloRequest.catalogFoodshiftsDetail(id)).data;
const updateFoodShift = async (payload: UpdateFoodShiftPayload) =>
  (await ropoloRequest.catalogFoodshiftsUpdate(payload)).data;
const createFoodShiftService = async (payload: CreateFoodShiftPayload) =>
  (await ropoloRequest.catalogFoodshiftsCreate(payload)).data;
export { getFoodShifts, updateFoodShift, createFoodShiftService, getFoodShiftsId, getAllFoodShifts };
